import { type ChangeEvent } from 'react';
import { cn } from '@/utils/cn';
import type { FieldErrors, SignupFields } from '../hooks/use-form-state';

export type SignupData = SignupFields;

export type FieldProps = {
  data: SignupData;
  onChange: (d: SignupData) => void;
  errors?: FieldErrors;
};

export const INPUT = cn(
  'w-full rounded-lg border border-white/[0.08] bg-white/[0.05] backdrop-blur-xl',
  'px-md py-sm text-sm text-text-primary',
  'placeholder:text-text-tertiary focus:border-brand-red/50 focus:outline-none',
  'transition-colors'
);

export const SELECT = cn(INPUT, 'appearance-none');

export function field(
  data: SignupData,
  onChange: FieldProps['onChange'],
  key: keyof SignupData
): (e: ChangeEvent<HTMLInputElement>) => void {
  return (e) => onChange({ ...data, [key]: e.target.value });
}

export type FieldDef = {
  key: keyof SignupData;
  type?: string;
  placeholder: string;
};
